import followUp from '@/views/followUp/followUp'
import details from '@/views/followUp/followUpDetails'

export default [
  {
    path: '/followUp',
    name: 'followUp',
    component: followUp,
    meta: {
      title: '随访记录',
      requireAuth: false,
      requireUserInfo: true
    }
  },
  {
    path: '/followUpDetails',
    name: 'followUpDetails',
    component: details,
    meta: {
      title: '随访详情',
      requireAuth: false,
    }
  },

]



// WEBPACK FOOTER //
// ./src/router/followUp.js